import React, { Component } from "react";
import { NavLink } from "react-router-dom";

import styles from "./Services.module.scss";
import PulverizingLogo from "../Graphics/PulverizingLogo";
import screen from "../../../media/images/screenblue.png";
import blend from "../../../media/images/blendingblue.png";
import BlendingLogo from "../Graphics/BlendingLogo";
import RepackagingLogo from "../Graphics/RepackagingLogo";

class Servcies extends Component {
  render() {
    return (
      <div id={styles.capabilitiesSection}>
        <div id={styles.capabilitiesHeader}>Our Services</div>
        <div id={styles.capabilitiesContainer}>
          <div className={styles.capabilitiesRow}>
            <NavLink
              to="/manufacturing-capabilities/pulverizing"
              className={styles.capabilities}
            >
              <div className={styles.icon}>
                <PulverizingLogo />
              </div>
              Pulverizing
            </NavLink>
            <NavLink
              to="/manufacturing-capabilities/screening"
              className={styles.capabilities}
            >
              <div
                className={styles.icon}
                style={{
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundImage: `url(${screen})`
                }}
              />
              Screening
            </NavLink>
          </div>
          <div className={styles.capabilitiesRow}>
            <NavLink
              to="/manufacturing-capabilities/blending"
              className={styles.capabilities}
            >
              <div
                className={styles.icon}
                style={{
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundImage: `url(${blend})`
                }}
              />
              Blending
            </NavLink>
            <NavLink
              to="/manufacturing-capabilities/repackaging"
              className={styles.capabilities}
            >
              <div className={styles.icon}>
                <RepackagingLogo />
              </div>
              Repackaging
            </NavLink>
          </div>
        </div>
      </div>
    );
  }
}

export default Servcies;
